import {
  CHATEXPENSES_ALL,
  CHATEXPENSES_GET,
  CHATEXPENSES_PUT,
  CHATEXPENSES_DEL,
  CHATEXPENSES_POST,
  CHATEXPENSES_RESET,
  CHATEXPENSES_LOADING,
  CHATEXPENSES_ERROR,
} from '../../actions/types';

const initialState = {
  chatExpenses: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case CHATEXPENSES_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case CHATEXPENSES_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case CHATEXPENSES_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case CHATEXPENSES_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case CHATEXPENSES_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case CHATEXPENSES_RESET:
      return { chatExpenses: null, isLoading: true, isCompleted: true };
    case CHATEXPENSES_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case CHATEXPENSES_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
